// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');
  var ReportDesignerDataSourceDetail = require('./Izenda.ReportDesignerDataSourceDetail');
  var ReportDesignerDataTree = require('./Izenda.ReportDesignerDataTree');
  var trackable = require('share/tracking/Izenda.Trackable');
  const { forEach, remove } = require('lodash/fp');

  function ReportDataSource() {
    var props = {
      dataTree: new ReportDesignerDataTree(),
      dataSourceDetail: new ReportDesignerDataSourceDetail(),
      reportMode: null,
      allowNull: false,
      distinct: false,
      filterParams: []
    };

    m.extendObservable(trackable(this), props);

    this.cleanDirty();
  }

  /**
   * Check dirty
   */
  ReportDataSource.prototype.checkDirty = function() {
    return this.isDirty || this.dataTree.checkDirty() || this.dataSourceDetail.checkDirty();
  };

  /**
   * Clean dirty
   */
  ReportDataSource.prototype.cleanDirty = function() {
    return this.resetDirty() || this.dataTree.cleanDirty() || this.dataSourceDetail.cleanDirty();
  };

  /**
   * Reset View
   */
  ReportDataSource.prototype.resetDataSourceModel = function() {
    // Reset filter text
    this.dataTree.filterText = '';
  };

  /**
   * Update Distinct value
   * @param {type} value
   */
  ReportDataSource.prototype.changeDistinct = function(value) {
    this.distinct = value;
    this.markDirty();
  };

  /**
   * Update Allow null value
   * @param {type} value
   */
  ReportDataSource.prototype.changeAllowNull = function(value) {
    this.allowNull = value;
    this.markDirty();
  };

  /**
   * Set report mode
   * @param {type} value
   */
  ReportDataSource.prototype.readReportMode = function(reportMode) {
    this.reportMode = reportMode;
    return null;
  };

  /**
   * Set distinct
   * @param {boolean} value
   */
  ReportDataSource.prototype.readDistinct = function(value) {
    this.distinct = value;
  };

  /**
   * [addFilterParams update list filter which is parameter]
   * @param {object} dataObject
   */
  ReportDataSource.prototype.addFilterParams = m.action(function(dataObject) {
    var filterFields = dataObject.fields;

    dataObject &&
      forEach(
        function(field) {
          field.isParameter === true ? this.filterParams.push(field) : null;
        }.bind(this),
        filterFields
      );
    this.markDirty();

    return Promise.resolve();
  });

  /**
   * [removeFilterParams remove filter paramerter]
   * @param  {object} dataObject
   */
  ReportDataSource.prototype.removeFilterParams = m.action(function(dataObject) {
    dataObject &&
      forEach(
        function(field) {
          this.filterParams = remove(function(filter) {
            return filter.id === field.id;
          }, this.filterParams);
        }.bind(this),
        dataObject.fields
      );
    this.markDirty();
  });

  /**
   * Read data source grid
   * Use in Report Viewer only , no need to create class ReportDesignerRelationshipDetail
   */
  ReportDataSource.prototype.readDataSourceGrid = function(relationships) {
    this.dataSourceDetail.dataSourceGrid = relationships;
  };

  module.exports = ReportDataSource;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ReportDesignerDataSource.js